/**
 * 错误类型定义
 */

/**
 * 错误类型枚举
 */
export enum ErrorType {
  API = 'API',
  NETWORK = 'NETWORK',
  VALIDATION = 'VALIDATION',
  AUTHENTICATION = 'AUTHENTICATION',
  PERMISSION = 'PERMISSION',
  NOT_FOUND = 'NOT_FOUND',
  SERVER = 'SERVER',
  CLIENT = 'CLIENT',
  UNKNOWN = 'UNKNOWN',
}

/**
 * API错误响应接口
 */
export interface ApiErrorResponse {
  code: number;
  message: string;
  data?: any;
  [key: string]: any;
}

/**
 * 错误日志接口
 */
export interface ErrorLog {
  id?: string;
  timestamp: string;
  type: ErrorType;
  message: string;
  context?: string;
  error: {
    name: string;
    message: string;
    stack?: string;
  };
  userAgent?: string;
  url?: string;
  userId?: string;
}

/**
 * 自定义应用错误接口
 */
export interface AppError extends Error {
  type: ErrorType;
  code?: string | number;
  details?: any;
  timestamp: number;
}

/**
 * 错误处理选项接口
 */
export interface ErrorHandlerOptions {
  showError?: boolean;
  customMessage?: string;
  onError?: (error: any) => void;
}

/**
 * 错误提示选项接口
 */
export interface ErrorToastOptions {
  title?: string;
  showDetail?: boolean;
  onConfirm?: () => void;
}

/**
 * HTTP状态码到错误类型的映射
 */
export const HTTP_STATUS_TO_ERROR_TYPE: Record<number, ErrorType> = {
  400: ErrorType.CLIENT,
  401: ErrorType.AUTHENTICATION,
  403: ErrorType.PERMISSION,
  404: ErrorType.NOT_FOUND,
  405: ErrorType.CLIENT,
  406: ErrorType.CLIENT,
  407: ErrorType.NETWORK,
  408: ErrorType.NETWORK,
  409: ErrorType.CLIENT,
  410: ErrorType.CLIENT,
  422: ErrorType.VALIDATION,
  429: ErrorType.NETWORK,
  500: ErrorType.SERVER,
  501: ErrorType.SERVER,
  502: ErrorType.SERVER,
  503: ErrorType.SERVER,
  504: ErrorType.SERVER,
  505: ErrorType.SERVER,
};

/**
 * 常见错误代码映射
 */
export const ERROR_CODE_MAPPING: Record<string | number, string> = {
  // 认证相关错误
  '401': '认证失败，请重新登录',
  '403': '无权限执行此操作',
  'TOKEN_EXPIRED': '登录已过期，请重新登录',
  'INVALID_TOKEN': '无效的令牌',
  
  // 网络相关错误
  'NETWORK_ERROR': '网络连接失败，请检查网络设置',
  'TIMEOUT': '请求超时，请稍后重试',
  'SERVER_ERROR': '服务器繁忙，请稍后再试',
  
  // 业务逻辑错误
  'VALIDATION_ERROR': '数据验证失败，请检查输入',
  'RESOURCE_NOT_FOUND': '请求的资源不存在',
  'DUPLICATE_RECORD': '记录已存在',
  'QUOTA_EXCEEDED': '超出配额限制',
  
  // 系统错误
  'INTERNAL_ERROR': '系统内部错误，请联系管理员',
  'UNKNOWN_ERROR': '发生未知错误，请稍后重试',
};